<template>
  <v-container fluid class="pa-0" fill-height>
    <v-row no-gutters :style="{'align-self': 'stretch'}" stretch>
      <v-col cols="3">
        <v-card elevation="0">
          <v-sheet class="pa-2 white">
            <v-text-field
              label="Search Conversations"
              solo-inverted
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
          </v-sheet>
          <v-card-text class="pa-0">
            <v-list two-line v-if="(pendingInvites.length != 0)">
              <v-divider></v-divider>
              <span class="pa-2 section-header">covnersation invites</span>
              <v-divider></v-divider>
              <v-list-item v-for="(invite, i) in invites" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ inviteName(invite) }}</v-list-item-title>
                    <v-list-item-subtitle>{{ inviteMessage(invite) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-btn text @click="acceptInvite(invite)">
                      accept
                      <v-icon color="green" small right>fa-check-circle</v-icon>
                    </v-btn>
                  </v-list-item-icon>
              </v-list-item>
            </v-list>
            <v-progress-linear v-if="listLoading" indeterminate color="accent darken-2"></v-progress-linear>
            <v-list v-else three-line>
              <div v-if="(pendingInvites.length != 0)">
                <v-divider></v-divider>
                <span class="pa-2 section-header">conversations</span>
                <v-divider></v-divider>
              </div>
              <template v-for="(conversation, i) in conversationList">
                <v-divider v-if="conversation.divider" :key="i"></v-divider>
                <v-list-item v-else link :to="{name: 'conversation', params: { 'cid': conversation.data.id }}" :key="conversation.data.id">
                  <v-list-item-content>
                    <div>
                      <span v-for="(participant) in conversation.participants" :key="participant.doc.id">
                        <v-avatar :key="participant.doc.id" class="mr-2" :size="35" v-if="avatarImage(participant.entity)">
                            <v-img :src="avatarImage(participant.entity)"></v-img>
                        </v-avatar>
                        <v-avatar :key="participant.doc.id" color="accent" class="mr-2" :size="35" v-else>
                          {{ avatarLetters(participant.entity) }}
                        </v-avatar>
                      </span>
                    </div>
                    <v-list-item-subtitle>{{ lastMessage(conversation.messages) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text>{{conversation.data.date}}</v-list-item-action-text>
                    <v-list-item-action-text>Messages: {{ conversation.messages.length }}</v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col style="position: relative">
        <router-view :conversations="conversations" v-on:subscribeConversation="subscribeConversation"></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { avatarImage, avatarLetters, displayName } from '@/utils/entityDisplay'

export default {
  name: 'conversations',
  async mounted () {
    this.$store.dispatch('hearro/loadConversationInvites')
    await this.$store.dispatch('hearro/loadConversations')
    this.listLoading = false
  },
  data () {
    return {
      listLoading: true
    }
  },
  methods: {
    lastMessage (messages) {
      if (messages.length === 0) { return '' }
      const msg = messages[messages.length - 1]
      if ((msg.message_type || 0) === 1) {
        return 'HearRo Call'
      }
      return msg.body || ''
    },
    avatarImage (e) {
      return avatarImage(e)
    },
    avatarLetters (e) {
      return avatarLetters(e)
    },
    displayName (e) {
      return displayName(e)
    },
    inviteName (i) {
      return i.data.label || ''
    },
    inviteMessage (i) {
      if (i.meta) {
        return i.meta.message || ''
      }
      return ''
    },
    async acceptInvite (invite) {
      this.$store.dispatch('hearro/acceptConversationInvite', { id: invite.id })
    },
    async subscribeConversation (cid) {
      console.log('sub convo', cid)
      const subscription = await this.$store.dispatch('hearro/subscribeConversationMessageStream', { conversationId: cid })
      console.log(subscription)
    }
  },
  computed: {
    conversationList () {
      const conversations = this.$store.getters['hearro/conversations']
      const divided = []
      conversations.forEach((element, i) => {
        // this.getRecentMessage(element.data.id)
        element.data.date = new Intl.DateTimeFormat().format(new Date(element.data.created))
        divided.push(element)
        if (i < conversations.length - 1) {
          divided.push({ divider: true })
        }
      })
      return divided
    },
    pendingInvites () {
      const inv = []
      this.invites.forEach(i => {
        if (i.meta.invitee === this.user.user.id) {
          inv.push(i)
        }
      })
      return inv
    },
    ...mapGetters({
      user: 'hearro/loggedInUser',
      conversations: 'hearro/conversations',
      invites: 'hearro/conversationInvites'
    })
  }
}
</script>
